import { createFormContext } from '@mantine/form'
import { AuthenticationFormValues } from 'components/business/Authentication'

export interface SignupFormValues extends AuthenticationFormValues {
  agreement: boolean
  accountName: string
}

export const [SignupFormProvider, useSignupFormContext, useSignupForm] = createFormContext<SignupFormValues>()
